import React, {useState, useContext, useEffect} from "react";
import {
   BodyForm,
   ContainerButtons,
   ButtonOption,
   SubtitleAuth,
   InputAuth,
   LabelAuth,
   MultiComponent,
   SectionSeparator,
   LabelLinks,
} from "./AuthStyles";
import Checker from "./Checker";
import Select from "../../../components/Select";
import Color from "../../../assets/Colors";
import Text from "../../../styles/Text";
import styled from "styled-components";
import {GlobalContext} from "../../../context/GlobalContext";
import {LoadComponet} from "../../../components/loaders/Loader";
import CitiesSelect from "./CitiesSelect";

export default function GetUpdateComponent({errorsList}) {
   const [hasExperience, setHas] = useState(false);
   const [certified, setCertified] = useState("");
   const {userData} = useContext(GlobalContext);
   const [Days] = useState(createArrayNumbers(1, 31));
   const [Months] = useState(createArrayNumbers(1, 12));
   const [Years] = useState(createArrayNumbers(new Date().getFullYear() - 90, 90 - 17).reverse());

   useEffect(() => {
      setHas(userData.industryExperience);
      let newCert = userData.certification
         ? userData.certification === "Wine and Spirits Education Trust" ||
           userData.certification === "Court of Master Sommeliers" ||
           userData.certification === "Certified Specialist of Wine"
            ? userData.certification
            : "otro"
         : "";
      setCertified(newCert);
   }, [userData]);

   const isError = (name) => {
      let findName = errorsList.find((er) => er.name === name);
      return findName ? "error" : "";
   };

   if (!userData) return <LoadComponet isVisible={true} />;
   return (
      <>
         <BodyForm>
            <SubtitleUpdate transform="uppercase">Información personal</SubtitleUpdate>

            <LabelUpdate>Nombre:</LabelUpdate>
            <InputAuth placeholder="Nombre*" type="text" defaultValue={userData.userName} required name="name" />

            <LabelUpdate>Apellido:</LabelUpdate>
            <InputAuth placeholder="Apellido*" type="text" defaultValue={userData.userLastName} required name="userLastName" />

            <MultiComponent>
               <LabelUpdate className="noMargin">*Fecha de nacimiento:</LabelUpdate>
               <div className="inputMin">
                  <Select id="dateDay" name="dateDay" placeholder={{value: "0", name: "DD"}} options={Days} />
               </div>
               <div className="line" />
               <div className="inputMin">
                  <Select id="dateMonth" name="dateMonth" placeholder={{value: "0", name: "MM"}} options={Months} />
               </div>
               <div className="line" />
               <div className="inputMin year">
                  <Select id="dateYear" name="dateYear" placeholder={{value: "0", name: "YYYY"}} options={Years} />
               </div>
            </MultiComponent>

            <MultiComponent>
               <LabelUpdate className="noMargin">*Sexo:</LabelUpdate>
               <Checker type="radio" name="idSex" value="1" title="H" defaultChecked={Number(userData.idSex) === 1} />
               <Checker type="radio" name="idSex" value="2" title="M" defaultChecked={Number(userData.idSex) === 2} />
            </MultiComponent>

            <MultiComponent>
               <LabelUpdate className="">*Ciudad:</LabelUpdate>
               <CitiesSelect defaultCity={userData.city} />
            </MultiComponent>

            <SectionSeparator />

            <SubtitleUpdate transform="uppercase">EXPRECIENCIA profesional</SubtitleUpdate>

            <LabelUpdate>¿Tienes experiencia en la industria?</LabelUpdate>

            <MultiComponent>
               <Checker
                  type="radio"
                  name="industryExperience"
                  value={1}
                  title="Sí"
                  defaultChecked={Number(userData.industryExperience) === 1}
                  change={(e) => {
                     console.log("hasExperience", e.target.value);
                     setHas(e.target.value);
                  }}
               />
               <Checker
                  type="radio"
                  name="industryExperience"
                  value={0}
                  title="No"
                  defaultChecked={Number(userData.industryExperience) === 0}
                  change={(e) => {
                     console.log("hasExperience", e.target.value);
                     setHas(e.target.value);
                  }}
               />
            </MultiComponent>
            {Number(hasExperience) === 1 && (
               <>
                  <LabelUpdate>¿Tienes alguna certificación?</LabelUpdate>
                  <Select
                     id="certified"
                     name="certified"
                     defaultValue={certified}
                     options={[
                        {value: "Wine and Spirits Education Trust", name: "Wine and Spirits Education Trust"},
                        {value: "Court of Master Sommeliers", name: "Court of Master Sommeliers"},
                        {value: "Certified Specialist of Wine", name: "Certified Specialist of Wine"},
                        {value: "otro", name: "Otro"},
                     ]}
                     change={(e) => {
                        setCertified(e.target.value);
                     }}
                  />
                  {certified === "otro" && (
                     <MultiAdjust>
                        <LabelUpdate>Especifica</LabelUpdate>
                        <InputAuth
                           placeholder="Certificación"
                           type="text"
                           defaultValue={userData.certified}
                           required
                           name="certifiedName"
                        />
                     </MultiAdjust>
                  )}
               </>
            )}

            {Number(hasExperience) === 1 && (
               <>
                  <LabelAuth>¿Cuántos años de experiencia tienes?</LabelAuth>
                  <Select
                     id="idExpYears"
                     name="idExpYears"
                     defaultValue={userData.idExpYears}
                     options={[
                        {value: 1, name: "1 a 3 años"},
                        {value: 2, name: "3 a 5 años"},
                     ]}
                  />
               </>
            )}
            {Number(hasExperience) === 1 && (
               <>
                  <LabelAuth>¿Dónde trabajas actualmente?</LabelAuth>
                  <InputAuth placeholder="Lugar de trabajo" type="text" required name="workplace" defaultValue={userData.workplace} />
               </>
            )}
            {Number(hasExperience) === 1 && (
               <>
                  <LabelAuth>¿Cuántos años de experiencia tienes?</LabelAuth>
                  <Select
                     id="position"
                     name="position"
                     defaultValue={userData.position}
                     options={[
                        {value: 1, name: "Mesero"},
                        {value: 2, name: "Capitán"},
                        {value: 3, name: "Propietario"},
                        {value: 4, name: "Gerente"},
                        {value: 5, name: "Bartender"},
                        {value: 6, name: "Somelier"},
                     ]}
                  />
               </>
            )}

            <SectionSeparator />

            <SubtitleUpdate transform="uppercase">Información de registro</SubtitleUpdate>

            <LabelUpdate>* Email:</LabelUpdate>
            <InputAuth placeholder="Mail*" type="email" required name="email" className={isError("email")} defaultValue={userData.email} />

            <LabelUpdate>* Contraseña:</LabelUpdate>
            <InputAuth
               placeholder="Contraseña*"
               type="password"
               required={false}
               name="pwd"
               className={isError("password")}
               autocomplete="off"
            />

            <LabelUpdate>* Confirmar contraseña:</LabelUpdate>
            <InputAuth
               placeholder="Confirmar contraseña*"
               type="password"
               required={false}
               name="pwdConfirm"
               className={isError("password")}
               autocomplete="off"
            />

            <LabelUpdate className="bottomMargin">* Pregunta de seguridad:</LabelUpdate>

            <Select
               id="question"
               name="idSecurityQuestion"
               defaultValue={userData.idSecurityQuestion}
               placeholder={{value: "0", name: "Selecciona una pregunta de seguridad"}}
               options={[
                  {value: 1, name: "¿Pregunta de seguridad 1?"},
                  {value: 2, name: "¿Pregunta de segurdidad 2?"},
               ]}
            />

            <LabelUpdate>* Respuesta:</LabelUpdate>
            <InputAuth
               placeholder="Escribe la respuesta a la pregunta de seguridad*"
               defaultValue={userData.securityAnswer}
               type="text"
               required={false}
               name="securityAnswer"
            />

            <MultiComponent>
               <Checker type="checkbox" name="newsletter" value="newsletter" title="Deseo suscribirme al newsletter" />
            </MultiComponent>

            <ErrorContainer>
               {errorsList &&
                  React.Children.toArray(
                     errorsList.map((item) => {
                        if (!item.text) return null;
                        return (
                           <Text color="crimson" as="li">
                              {item.text}
                           </Text>
                        );
                     }),
                  )}
            </ErrorContainer>

            <ContainerButtons width="40%">
               <ButtonOption className="widthAuto">Guardar</ButtonOption>
            </ContainerButtons>

            <ContainerButtons width="100%">
               <LabelLinks as="label" color={Color.textColor} decoration="none">
                  Al dar click en crear cuenta el usuario acepta los{" "}
                  <LabelLinks color={Color.textColor} to="/terminos_condiciones">
                     TÉRMINOS Y CONDICIONES{" "}
                  </LabelLinks>{" "}
                  así como las{" "}
                  <LabelLinks color={Color.textColor} to="/privacidad">
                     POLÍTICAS DE PRIVACIDAD DEL SITIO{" "}
                  </LabelLinks>{" "}
                  del sitio.
               </LabelLinks>
            </ContainerButtons>
         </BodyForm>
      </>
   );
}

function createArrayNumbers(start, item) {
   let base = new Array(item).fill("x");
   let toReturn = Object.keys(base).map((x) => {
      let option = {value: start + Number(x), name: start + Number(x)};
      return option;
   });
   return toReturn;
}

const MultiAdjust = styled(MultiComponent)`
   margin: 0 0 1.5em 0;
`;

const SubtitleUpdate = styled(SubtitleAuth)`
   color: ${Color.primary};
`;

const LabelUpdate = styled(LabelAuth)`
   color: ${Color.primary};
   font-weight: 400;
   padding-bottom: 0;
   padding-top: 0;
   margin-top: 1.5em;

   &.noMargin {
      margin-top: 0;
   }

   &.bottomMargin {
      margin-bottom: 1em;
   }
`;

const ErrorContainer = styled.ul`
   margin-top: 1em;

   & li {
      margin-top: 0.2em;
      font-size: 1.2em;
   }

   @media screen and (max-width: 1600px) {
      & li {
         margin-top: 0.2em;
         font-size: 0.9em;
      }
   }
`;

/*<SubtitleUpdate transform="uppercase">experiencia profesional</SubtitleUpdate>

<LabelUpdate>¿Tienes experiencia en la industria?</LabelUpdate>

<MultiComponent>
  <Checker type="radio" name="experience" value="1" title="Sí" />
  <Checker type="radio" name="experience" value="0" title="No" />
</MultiComponent>

<LabelAuth margin="2em 0 0 0">¿Tienes alguna certificación?</LabelAuth>
<Select id="hasCertified" name="hasCertified" />
<MultiComponent>
  <LabelAuth>Especifica: </LabelAuth>
  <Select id="certified" name="certified" />
</MultiComponent>*/
